<div 
  class="box-1" 
  [style]="'padding:' + padding() + 'px;' + 
           '--borderWidth:' + borderWidth() + 'px;' +
           '--borderRadius:' + borderRadius() + 'px;' + 
            'backgroundColor:' + backgroundColor() + ';' +
            (backdropFilterBlur() > 0 ? '--backdropFilterBlur:' + backdropFilterBlur() + 'px;' : '')
          " 
>
  <ng-content />
</div>